<ng-container *ngIf="managerStates$ | async as managerStates">
  <ng-container *ngIf="personalManagers$ | async as obs">
    <div *ngIf="obs.personalManagers.length === 0">
      <div class="no-managers-text">
        При переходе в сегмент «Эксперт» за вами закрепляется персональный менеджер.
        <br />
        Он проконсультирует по заказам и товарам
      </div>
      <div class="offer-terms"><a sdLink [routerLink]="'/loyalty_program'">условия оферты</a></div>
    </div>
    <sd-personal-manager-template *ngFor="let manager of obs.personalManagers" [manager]="manager">
      <ng-container *ngIf="managerStates[manager.uid] as managerState">
        <ng-container
          *ngIf="{
            loadingDelete: managerState.loadingDelete$ | async,
            loadingApprove: managerState.loadingApprove$ | async,
          } as obs"
        >
          <button
            (click)="approveManager(manager.uid)"
            sdButton
            [disabled]="obs.loadingDelete"
            [loading]="obs.loadingApprove"
            type="accent"
            class="btn"
            fullWidth="true"
          >
            Принять
          </button>
          <button
            (click)="deleteManager(manager.uid)"
            sdButton
            [disabled]="obs.loadingApprove"
            [loading]="obs.loadingDelete"
            type="outlined-gray"
            class="btn"
            fullWidth="true"
          >
            Отклонить
          </button>
        </ng-container>
      </ng-container>
    </sd-personal-manager-template>
  </ng-container>
</ng-container>
